export const LLM_PROVIDERS = {
  OPENAI: "openai",
  ANTHROPIC: "anthropic",
  GOOGLE: "google",
};

export const DEFAULT_MODEL = "gemini-3.5-flash-lite";

/** Models Global Admins can pick for new P1 prompts. Stored ids not in this list still execute. */
export const MODEL_OPTIONS = [
  "gemini-3.6-flash",
  "gemini-3.5-flash-lite",
  "gpt-5.6-terra",
  "gpt-5.6-luna",
  "claude-sonnet-5",
];

export const LLM_COLLECTIONS = {
  QUERY_CONFIG: "llmQueryConfig",
  QUERIES: "llmQueries",
  VERSIONS: "llmQueryVersions",
  CHAINS: "llmQueryChains",
  GLOBAL_PROMPTS: "llmGlobalPrompts",
  LOCAL_PROMPTS: "llmLocalPrompts",
  HIERARCHY_PROMPTS: "llmHierarchyPrompts",
  HIERARCHY_NODES: "hierarchyNodes",
};

export const CHAIN_MODE = {
  SEQUENTIAL: "sequential",
  SUBSTITUTIONARY: "substitutionary",
};
